import api from "../utils/api";
import {
    LOGOUT
} from "./types";
import { pack } from "./alert";

export const search = ({ page = 0, size = 10, order = "lastName", direction = "asc", search = null, assignment = "case", uuid=null }) => async (dispatch) => {
    try {
        const res = await api.get(`/cases/staff/p/${page}/s/${size}/o/${order}/${direction}/a/${assignment}/${uuid}/${search}`);
        return res.data;
    } catch (err) {
        console.log(err);
        //dispatch({ type: LOGOUT });
    }
}

export const save = (
    {
        uuid,
        caseUuid,
        staffUuid,
        rate,
        assignmentDate,
        removalDate
    }) => async (dispatch) => {
        try {
            const res = await api.post(`/cases/staff`, {
                uuid,
                caseUuid,
                staffUuid,
                rate,
                assignmentDate,
                removalDate
            });
            dispatch(pack(["Matter staff saved"], "success"));
            return res.data;
        } catch (err) {
            dispatch({
                type: LOGOUT
            });
        }
    }

export const batch = (
    {
        caseUuid,
        items
    }) => async (dispatch) => {
        try {
            const res = await api.post(`/cases/staff/batch`, {
                caseUuid,
                items
            });
            dispatch(pack(["Matter staff saved"], "success"));
            return res.data;
        } catch (err) {
            dispatch({
                type: LOGOUT
            });
        }
    }